import {
  TextContent,
  SpaceBetween,
  Link,
  Alert,
} from "@amzn/awsui-components-console";
import SimLinkGenerator from "../../components/simLinkGenerator/SimLinkGenerator";
import { SIM_TYPES } from "../../components/simLinkGenerator/types";
import { MAX_FILENAME_SIZE } from "../FileUpload/constants";
import React from "react";

export const renderWcAlert = (
  simType: SIM_TYPES,
  claimModel: any,
  fileAttachmentTicketUrl?: string
) => (
  <React.Fragment>
    <TextContent>
      <SpaceBetween direction="vertical" size="xxxs">
        <div>
          Click on &quot;Choose File(s)&quot; or drag and drop to upload files.
        </div>
        <div>
          Supported formats are .jpeg, .jpg, .png, .doc, .pdf, .gif, .rtf, .tif,
          .txt, .docx. Each file cannot exceed 6MB and a total of 29MB for all
          files combined. File names cannot be longer than {MAX_FILENAME_SIZE}{" "}
          characters.
        </div>
        <div>
          If you want to upload a video or if the file type is not supported or
          exceeds the size limit, kindly follow the existing process by creating
          a{" "}
          {fileAttachmentTicketUrl ? (
            <Link
              href={fileAttachmentTicketUrl}
              target="_blank"
              ariaLabel="Press this link to open a new tab where you will be able to create a ticket to upload videos or files that exceed the size limit."
              external
            >
              ticket.{" "}
            </Link>
          ) : (
            <SimLinkGenerator
              simType={simType}
              claimModel={claimModel}
              target="_blank"
              ariaLabel="Press this link to open a new tab where you will be able to create a ticket to upload videos or files that exceed the size limit."
            >
              ticket.{" "}
            </SimLinkGenerator>
          )}
          To initiate the process, please complete the claim submission to
          obtain a unique claim number. Ensure that you enter this claim number
          while creating the ticket.
        </div>
      </SpaceBetween>
    </TextContent>
  </React.Fragment>
);

export const renderCargoAlert = (
  triggerFileDownload: (fieldName: string) => void,
  fieldName: string
) => (
  <TextContent>
    If you are claiming for more than one item please{" "}
    <Link onClick={() => triggerFileDownload(fieldName)}>
      download this excel file
    </Link>
    , complete one row for each item being claimed for, then upload the
    completed spreadsheet. Alternatively if you already have an Excel file
    containing the details of the damaged/missing items you wish to claim for
    please upload this file instead
  </TextContent>
);

export const renderDocumentEncouragementAlert = () => (
  <Alert
    type="info"
    i18nStrings={{ dismissAriaLabel: "Dismiss", infoIconAriaLabel: "Info" }}
  >
    To prevent delays in claim processing, submission of documents is not
    mandatory. However, it is strongly encouraged to provide supporting
    documents.
  </Alert>
);
